import { useCallback } from 'react'
import { toast } from 'react-hot-toast'
import { useNavigate } from 'react-router'
import { useMutation } from '@tanstack/react-query'

import API from '@shared/services/src/API'
import { handleError, includesOneOfErrorMessages, UserRole } from '@shared/utils'

import useFormatMessage from '@hooks/useFormatMessage'

export const providerToUser = (provider) => (provider ? { ...provider, id: provider.userId, role: UserRole.Provider } : undefined)

export default function useConversationWithUser() {
  const navigate = useNavigate()
  const formatMessage = useFormatMessage()
  const { mutateAsync: findConversation } = useMutation({
    mutationFn: (userId) => API.conversations.list({ user_id: userId, between_users: true, limit: 1 }, { skipHandling: true }),
  })

  return useCallback(
    async (userId, options = {}) => {
      const { replace = false, user, requestPath = `/app/messages/new/${userId}` } = options

      try {
        const conversation = await findConversation(userId).then((conversations) => conversations?.[0])

        if (conversation) {
          navigate(`/app/messages/${conversation.id}`, { replace })
        } else {
          navigate(requestPath, { replace, state: { user } })
        }
      } catch (error) {
        if (includesOneOfErrorMessages(error, ['does not has permissions on this endpoint'])) {
          toast.error(formatMessage('error.conversation.permission.message'))
        } else {
          handleError(error)
        }
      }
    },
    [findConversation, formatMessage, navigate]
  )
}
